export default "__VITE_ASSET__f267ae26__"